import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { business } from "@/data/siteConfig";

/** True on touch / small-screen devices where a tel: call should fire directly. */
export function useIsTouch() {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px), (pointer: coarse)");
    const update = () => setTouch(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return touch;
}

/**
 * Phone-first conversion helper.
 * - Mobile / touch  -> let the tel: link initiate a call.
 * - Desktop         -> copy the number and show a confirmation toast.
 */
export function useCallAction() {
  const isTouch = useIsTouch();
  const onCall = useCallback(
    (e) => {
      if (!isTouch) {
        if (e) e.preventDefault();
        try {
          navigator.clipboard?.writeText(business.phone);
        } catch (_) {
          /* clipboard unavailable — link still works */
        }
        toast.success("Phone number copied", {
          description: `${business.phone} copied to clipboard — call us any time.`,
        });
      }
    },
    [isTouch],
  );
  return { isTouch, onCall, tel: `tel:${business.phoneTel}` };
}
